import React from 'react';

interface LogoProps {
  size?: number;
  animate?: 'pulse' | 'spin' | 'bounce' | 'none';
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ 
  size = 48, 
  animate = 'none',
  className = '' 
}) => {
  const animationClass = {
    pulse: 'animate-logo-pulse',
    spin: 'animate-logo-spin',
    bounce: 'animate-spring-bounce',
    none: ''
  }[animate];

  return (
    <div 
      className={`inline-block ${animationClass} ${className}`}
      style={{ width: size, height: size }}
    >
      <img 
        src="https://pupflkhgreielehxetyu.supabase.co/storage/v1/object/public/Public%20Asset/CarlineConsensor-PrimarySquare-Small.png"
        alt="Carline Consensor"
        className="w-full h-full object-contain"
      />
    </div>
  );
};

export default Logo;